import { socialLinksSchema, type SocialLink } from '@hue/contracts';

export function socialLinksError(value: SocialLink[]): string | undefined {
  const result = socialLinksSchema.safeParse(value);
  return result.success ? undefined : result.error.issues[0]!.message;
}
